__webpack_require__.p = "https://blockchain-monorepo.sandbox.securitize.io/";